module.exports = new __parcel__URL__("2cd55546-ec00-4af9-aeca-4a3cd186da53.ded3fdbc.woff2").toString();